import { ArrowRight, BadgeCheck } from "lucide-react";
import { formatFt } from "@/lib/pricing";

export default function CalcSummary({ t, result, onBook }) {
  const c = t.calculator;
  return (
    <div className="bg-[var(--primary)] text-white rounded-2xl p-6 sm:p-8 flex flex-col" data-testid="calc-summary">
      <div className="flex-1 space-y-2.5">
        {result.items.map((item) => (
          <div key={item.key} className="flex items-baseline justify-between gap-4 text-sm" data-testid={`calc-line-${item.key}`}>
            <span className="text-white/75">
              {c.breakdown[item.key]}
              {item.qty > 1 ? ` × ${item.qty}` : ""}
            </span>
            <span className="font-semibold whitespace-nowrap">{formatFt(item.sum)}</span>
          </div>
        ))}
      </div>
      <div className="border-t border-white/20 mt-5 pt-4 flex items-baseline justify-between gap-4">
        <span className="font-semibold">{c.total}</span>
        <span className="font-heading text-3xl sm:text-4xl" data-testid="calc-total">
          {formatFt(result.total)}
        </span>
      </div>
      <p className="text-xs text-white/60 mt-3 flex items-start gap-2">
        <BadgeCheck className="w-4 h-4 shrink-0 mt-0.5" />
        {c.note}
      </p>
      <button
        onClick={onBook}
        className="btn-primary w-full justify-center mt-5 !bg-[var(--accent)]"
        data-testid="calc-book-btn"
      >
        {c.cta}
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
